import { Button, ButtonGroup, Box, Text, Link, VStack } from '@chakra-ui/react';
import { ReactElement } from 'react';
import { formatDateTime, Modal, isSafeUrl } from 'shared-components';
import { useTranslation } from "react-i18next";

interface InterviewDetailsModalProps {
  isOpen: boolean;
  onClose: () => void;
  interviewName?: string | null;
  description?: string | null;
  startDate?: number;
  joinUrl?: string;
}

export const InterviewDetailsModal = ({
  isOpen,
  onClose,
  interviewName,
  description,
  startDate,
  joinUrl,
}: InterviewDetailsModalProps): ReactElement => {
    const { t } = useTranslation('common');
  const title = interviewName ? `${interviewName} details` : 'Interview details';
  const shouldRenderUrl = joinUrl && isSafeUrl(joinUrl);

  return (
    <Modal
      show={isOpen}
      onClose={onClose}
      title={title}
      footer={
        <ButtonGroup spacing={3} size="lg">
          <Button onClick={onClose}>Close</Button>
        </ButtonGroup>
      }
    >
      <VStack align="stretch" spacing={4}>
        {startDate && (
          <Box>
            <Text fontWeight="semibold" mb={1}>
              {t('common:dateTime')}
                                      </Text>
            <Text>{formatDateTime(new Date(startDate))}</Text>
          </Box>
        )}

        {description && (
          <Box>
            <Text fontWeight="semibold" mb={1}>
              {t('common:description')}
                                      </Text>
            <Text>{description}</Text>
          </Box>
        )}

        {shouldRenderUrl && (
          <Box>
            <Text fontWeight="semibold" mb={1}>
              {t('common:bookingDetails')}
                                      </Text>
            <Link href={joinUrl} isExternal>
              {joinUrl}
            </Link>
          </Box>
        )}
      </VStack>
    </Modal>
  );
};
